import React from "react";
import {ControlButton, Controls, useReactFlow} from "@xyflow/react";
import {Icon} from "../../components";

export interface ReactFlowZoomControlsProps {
    initialViewportRef: React.RefObject<{ x: number; y: number; zoom: number } | null>;
}

export const FAMILY_TREE_ZOOM_SCALE_MAX = 2;
export const FAMILY_TREE_ZOOM_SCALE_MIN = 0.3;
const ZOOM_SCALE_INCREMENT = 0.1;

const ReactFlowZoomControls: React.FC<ReactFlowZoomControlsProps> = ({ initialViewportRef }) => {
    const {getViewport, setViewport} = useReactFlow();

    const handleZoomIn = () => {
        const viewport = getViewport();
        if (!viewport || typeof viewport.zoom !== 'number') return;
        const {x, y, zoom} = viewport;
        const newZoom = Math.min(zoom + ZOOM_SCALE_INCREMENT, FAMILY_TREE_ZOOM_SCALE_MAX);
        setViewport({x, y, zoom: newZoom});
    };

    const handleZoomOut = () => {
        const viewport = getViewport();
        if (!viewport || typeof viewport.zoom !== 'number') return;
        const {x, y, zoom} = viewport;
        const newZoom = Math.max(zoom - ZOOM_SCALE_INCREMENT, FAMILY_TREE_ZOOM_SCALE_MIN);
        setViewport({x, y, zoom: newZoom});
    };

    const handleReset = () => {
        if (initialViewportRef.current) {
            setViewport(initialViewportRef.current);
        }
    };

    return (
        <div className="family-tree-reactflow-controls">
         <Controls showInteractive={false} showFitView={false} showZoom={false}>
             <ControlButton
                 onClick={handleZoomIn}
                 aria-label="Zoom In"
                 role="Family-Tree-Zoom-In"
             >
                <Icon name="zoom_in" className={"control-icon"}/>
            </ControlButton>
             <ControlButton
                 onClick={handleZoomOut}
                 aria-label="Zoom Out"
                 role="Family-Tree-Zoom-Out"
             >
                 <Icon name="zoom_out" className={"control-icon"}/>
             </ControlButton>
             <ControlButton
                 onClick={handleReset}
                 aria-label="Fit View"
                 role="Family-Tree-Zoom-Reset"
             >
                 <Icon name="fullscreen_exit" className={"control-icon"}/>
             </ControlButton>
         </Controls>
         </div>
     );
};

export default ReactFlowZoomControls;
